import React, { useState } from "react";
import { LeaveReports } from "./LeaveReport";
import * as Mui from "@mui/material";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { DownloadForOffline } from "@mui/icons-material";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { themes } from "services/constants";
import { useDispatch, useSelector } from "react-redux";
import { defaultAllSelection } from "services/constants";
import { useFetch } from "services/hooks/useFetch";
import moment from "moment";

export const LeaveAndPermission = ({ setShowReport }) => {
  const { domain, userDetails, topbarCompanyName } = useSelector(
    (state) => state.tokenReducer
  );
  const [departmentName, setDepartmentName] = useState("All");
  const [departmentId, setDepartmentId] = useState(defaultAllSelection);
  const [fetchDetails, setFetchDetails] = useState(true);
  const [leaveReportDetails, setLeaveReportDetails] = useState([]);
  const [masterLeaveDataForSearch, setMasterLeaveDataForSearch] = useState([]);
  const [startDate, setStartDate] = useState(
    moment().subtract(7, "day").format("DD/MM/YYYY")
  );
  const [endDate, setEndDate] = useState(
    moment().subtract(1, "day").format("DD/MM/YYYY")
  );
  const { result: departmentData } = useFetch(
    `${domain}get-department/?user_id=${userDetails.id}`
  );
  const dispatch = useDispatch();

  const getLeaveReport = () => {
    let dataPreparation = [];
    leaveReportDetails?.forEach((element) => {
      let overAllData = {
        employee_id: element?.employee_id || "N/A",
        username: element?.username || "N/A",
        department_name: element?.department_name || "N/A",
        paid_leave_count: element?.paid_leave_count ?? 0,
        unpaid_leave_count: element?.unpaid_leave_count ?? 0,
        absent_count: element?.absent_count ?? 0,
        permission_count: element?.permission_count ?? 0,
        missing_count: element?.missing_count ?? 0,
        late_early_count: element?.late_early_count ?? 0,
      };
      dataPreparation = [...dataPreparation, overAllData];
    });
    const LeaveReport = ["Leave Report"];
    const Dates = ["Date"];
    const companyName = ["Company Name"];
    const Department = ["Department Name"];
    const GeneratedOn = ["Report Generated On"];
    LeaveReport.push("");
    Dates.push(moment(startDate).format("DD/MM/YYYY"));
    companyName.push(topbarCompanyName);
    Department.push(departmentName);
    GeneratedOn.push(moment(new Date()).format("DD/MM/YYYY, hh:mm a"));
    const items = dataPreparation;
    const TableHead = [
      "Employee Id",
      "Employee Name",
      "Department",
      "Paid Leave",
      "Unpaid Leave",
      "Absent",
      "Permission",
      "Missing",
      "Late/Early",
    ];
    const replacer = (key, value) => (value === null ? "" : value);
    const header = Object.keys(items[0]);
    let csv = items.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(",")
    );
    csv.unshift(TableHead.join(","));
    csv.unshift(GeneratedOn.join(","));
    csv.unshift(Department.join(","));
    csv.unshift(companyName.join(","));
    csv.unshift(Dates.join(","));
    csv.unshift(LeaveReport.join(","));
    csv = csv.join("\r\n");
    const ConvertData = csv;
    const element = document.createElement("a");
    const file = new Blob([ConvertData], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = "LeaveReports.csv";
    document.body.appendChild(element);
    element.click();
  };

  const handleStartDate = async (startDate, endDate) => {
    setStartDate(
      moment(new Date(startDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setEndDate(
      moment(new Date(endDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setFetchDetails(true);
  };

  const updateDepartmentName = (event, data) => {
    if (data && data?.label) {
      setDepartmentName(data.label);
      setDepartmentId(data.id);
      setFetchDetails(true);
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2 }}>
        <Mui.Grid container spacing={1} sx={{ mt: 0 }}>
          <Mui.Grid item xs={12} sm={12} md={0.5} lg={0.5}>
            <BackArrow
              actionFunction={() => {
                setShowReport(false);
                dispatch(setGlobalSearchValue(""));
              }}
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={6} md={3} lg={2}>
            <BSDateRangePicker
              handleStartDate={handleStartDate}
              showToday={false}
              triggerDate={true}
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={6} md={3} lg={2}>
            <CustomAutoComplete
              dataList={[
                {
                  id: defaultAllSelection,
                  label: "All",
                  department_name: "All",
                },
                ...(departmentData?.map((obj) => ({
                  ...obj,
                  label: obj.department_name,
                })) ?? []),
              ]}
              selectedValue={departmentName}
              updateDataFunction={updateDepartmentName}
              placeHolder="Select department name"
              label="Department"
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={4} md={1} lg={1.5}></Mui.Grid>
          <Mui.Grid item lg={5.2}></Mui.Grid>
          <Mui.Grid item xs={2} sm={2} md={2} lg={0.5}>
            <Mui.IconButton
              onClick={() => {
                getLeaveReport();
              }}
              disabled={leaveReportDetails?.length === 0 ? true : false}
            >
              <DownloadForOffline
                size="large"
                sx={{ color: themes.downloadIconColor, fontSize: 40, mt: -1 }}
              />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.Grid>
      <Mui.Grid sx={{ padding: 0.5 }}>
        <LeaveReports
          setShowReport={setShowReport}
          startDate={startDate}
          endDate={endDate}
          setLeaveReportDetails={setLeaveReportDetails}
          setMasterLeaveDataForSearch={setMasterLeaveDataForSearch}
          masterLeaveDataForSearch={masterLeaveDataForSearch}
          leaveReportDetails={leaveReportDetails}
          fetchDetails={fetchDetails}
          setFetchDetails={setFetchDetails}
          departmentId={departmentId}
        />
      </Mui.Grid>
    </React.Fragment>
  );
};
